// view/fieldReset.js — puts fields back to their reset values when a reset button is clicked (plan
// documents_admin-search, phase 7c: tab 2 of the documents.php filter; the legacy reset in documents.js only knows the
// selects of tab 1). Markup: an input with data-reset-value="…" gets that value, a checkbox with
// data-reset-checked="true|false" that state. Delegated on the root (the filter table is replaced on every ajax reload).
//
// Returns { destroy }.

import { createDisposers } from '../core/disposers.js';

export function createFieldReset({ root = document, trigger }) {
    if (!trigger) {
        throw new Error('[fieldReset] trigger selector missing');
    }
    const disposers = createDisposers();

    const onClick = (ev) => {
        if (!ev.target.closest(trigger)) {
            return;
        }
        for (const field of root.querySelectorAll('[data-reset-value]')) {
            field.value = field.dataset.resetValue;
        }
        for (const box of root.querySelectorAll('[data-reset-checked]')) {
            box.checked = box.dataset.resetChecked === 'true';
        }
    };

    root.addEventListener('click', onClick);
    disposers.add(() => root.removeEventListener('click', onClick));

    return { destroy: () => disposers.dispose() };
}
